module.exports = __webpack_public_path__ + "static/media/18ECA31.82b15176.jpg";